import { useEffect, useState } from 'react'
import { connect, Provider } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { IsManual, PAID_MANUAL, paymentModes, TO_PAY_MANUAL, getPaymentMode, ONACCOUNT_MANUAL } from '../common/paymentsMode'
import LRdetails  from './lrDetails'
import { LrHeader } from './lrheader'
import { SearchForm } from './lrSearchForm'
import { LRSearchOption } from './lrSearchOption'
import { LRSearchResults } from './lrSearchResults'

function LrSearch(props) {
  const [searchParams, setSearchParams] = useSearchParams()
  const [currentView, setCurrentView] = useState(searchParams.get('page') || searchParams.get('p') || '')
  const LRSearchOpt = 'searchoption'
  const LRSearchRes = 'searchresult'
	const LRdetail = 'lrdetail'
  const { data } = props
  const { common} = data
  const { cnsgnmntTypes, companySettings } = common
  const [paymentTypes, setPaymentTypes] = useState(paymentModes)
  useEffect(() => {
    const search = window.location.search;
    const looksEncoded = /%[0-9A-F]{2}/i.test(search);
    if (search.startsWith('?') && looksEncoded) {
      try {
        const encodedQuery = search.substring(1);
        const decodedQuery = decodeURIComponent(encodedQuery);
        const newUrl = `${window.location.origin}${window.location.pathname}?${decodedQuery}`;
        window.location.replace(newUrl);
      } catch (err) {
        console.error('Failed to decode and redirect:', err);
      }
    }
  }, []);
  const getPage = (key) => {
    let activityUI
    switch (key.toLocaleLowerCase()) {
      case LRSearchOpt.toLocaleLowerCase():
        activityUI = <LRSearchOption />
        break
      case LRSearchRes.toLocaleLowerCase():
        activityUI = <LRSearchResults />
        break
      case 'l':
			case LRdetail.toLocaleLowerCase():
				activityUI = <LRdetails/>
				break
      default:
        activityUI = (
          <SearchForm
            paymentTypes={paymentTypes}
            setPaymentTypes={setPaymentTypes}
            cnsgnmntTypes={cnsgnmntTypes}
            companySettings={companySettings}
          />
        )
        break
    }
    return activityUI
  }
  return (
    <div className="mobileView">
      {/* <LrHeader /> */}
      {getPage(currentView)}
    </div>
  )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {}
export default connect(mapStateToProps, mapDispatchToProps)(LrSearch)
